(function () {
  let closeTimers = new WeakMap();

  function isDesktop() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function clampImageToCols(panel) {
    if (!panel) return;

    const cols = panel.querySelector('.mm-cols');
    const img = panel.querySelector('[data-mm-media] img, .mm-img');

    if (!cols || !img) return;

    img.style.maxHeight = '';
    img.style.height = 'auto';
    img.style.objectFit = 'cover';

    const colsHeight = cols.getBoundingClientRect().height;
    if (!colsHeight) return;

    const maxImgHeight = Math.round(colsHeight * 1.2);

    img.style.maxHeight = maxImgHeight + 'px';
    img.style.height = 'auto';
  }

  function openItem(item) {
    if (!item) return;

    const timer = closeTimers.get(item);
    if (timer) {
      clearTimeout(timer);
      closeTimers.delete(item);
    }

    document.querySelectorAll('.mm-item.is-mm-active').forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.classList.remove('is-mm-active');
      }
    });

    item.classList.add('is-mm-active');

    const panel = item.querySelector('.mm-panel');
    if (panel) {
      requestAnimationFrame(() => clampImageToCols(panel));
      setTimeout(() => clampImageToCols(panel), 50);
      setTimeout(() => clampImageToCols(panel), 150);
    }
  }

  function closeItemWithDelay(item) {
    if (!item) return;

    const oldTimer = closeTimers.get(item);
    if (oldTimer) clearTimeout(oldTimer);

    const timer = setTimeout(() => {
      item.classList.remove('is-mm-active');
      closeTimers.delete(item);
    }, 300);

    closeTimers.set(item, timer);
  }

  function closeAllItems() {
    document.querySelectorAll('.mm-item.is-mm-active').forEach((item) => {
      item.classList.remove('is-mm-active');
    });
  }

  function bind() {
    if (!isDesktop()) return;

    document.querySelectorAll('.mm-item').forEach((item) => {
      if (item.dataset.mmHoverBound === 'true') return;
      item.dataset.mmHoverBound = 'true';

      item.addEventListener('mouseenter', () => {
        openItem(item);
      });

      item.addEventListener('mouseleave', () => {
        closeItemWithDelay(item);
      });

      const panel = item.querySelector('.mm-panel');
      if (panel) {
        panel.addEventListener('mouseenter', () => {
          openItem(item);
        });

        panel.addEventListener('mouseleave', () => {
          closeItemWithDelay(item);
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllItems();
      }
    });

    window.addEventListener('resize', () => {
      document.querySelectorAll('.mm-panel').forEach((panel) => clampImageToCols(panel));
    });
  }

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();